import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClientsComponent } from './clients.component';
import { ClientContentComponent } from './client-content/client-content.component';

const routes: Routes = [
	{ path: '', component: ClientsComponent, children: [
		{ path: ':clientid', children: [
			{ path: '', component: ClientContentComponent },
			{ path: 'plans/:planid', component: ClientContentComponent },
			{ path: 'questionnaires/:questionnaireid', component: ClientContentComponent },
			{ path: 'users/:userid', component: ClientContentComponent }
		] }
	] },
	{ path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientsRoutingModule { }
